import faker from 'faker';
import {
  DietaryRestrictions,
  type CustomerProfile,
} from '../customer/create-customer';

export const customerProfile: CustomerProfile = {
  pricingConfig: {
    version: 3,
    breakfastPacks: 2,
    numLunch: 2,
    numDinner: 2,
    snackPacks: 1,
    sweetsPacks: 1,
    fruitPacks: 0,
    servingSize: 2,
    loading: false,
    shipping: 0,
    allow4Servings: false,
    firstBoxTotal: 86.72,
    subtotal: 123.89,
    promo_effect: {
      promos: [
        {
          code: '',
          type: 1,
          value: 30,
          is_expired: false,
          effect: '30% off',
        },
        {
          code: '',
          type: 2,
          value: 70,
          is_expired: false,
          effect: 'free shipping',
        },
      ],
      free_item_effect: '',
      discount_effect: '30% off',
      effect_str: 'Offer Applied: 30% off + free shipping!',
      effect_base: '30% off + free shipping',
    },
  },
  quiz: {
    household_size: 1,
    num_adults: 1,
    num_young_children: 0,
    num_older_children: 0,
  },
  dietary: [DietaryRestrictions.Omnivore],
  address: {
    name: 'HR Dev Tools',
    address1: faker.address.streetAddress(),
    address2: '',
    city: faker.address.city(),
    state: 'NY',
    zip_code: '10010',
    phone: '1234567890',
    company: faker.company.companyName(),
    note: '',
    is_commercial: false,
    sms_opt_in: false,
  },
  paymentInfo: {
    stripe_token: 'tok_us',
  },
};
